import * as React from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'

interface Props {
  text: string
}
const HeaderCell = ({ text }: Props) => {
  return (
    <Table.HeadCell ellipsis>
      <Box paddingY="s12" width="s200">
        <Text.Normal ellipsis>{text}</Text.Normal>
      </Box>
    </Table.HeadCell>
  )
}
export default HeaderCell
